import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { var_api } from '../../constant';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import sage from "../../../images/splash/sage.jpeg";
import Loader from "../Loader";
import Modal from 'react-bootstrap/Modal';

export default function RoleMaster() {
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [permissionList, setPermissionList] = useState([]);
    const [popup, setPopup] = useState(false);
    const [isRoleValid, setIsRoleValid] = useState(true);
    const [isDescriptionValid, setIsDescriptionValid] = useState(true);
    const [isActive, setIsActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [role, setRole] = useState('');
    const [description, setDescription] = useState('');
    const [isLogin, setIsLogin] = useState(false);

    // Check if the user is logged in
    useEffect(() => {
        // checkToken();
        getPermission();
        getPermission1();
    }, []);

    // const checkToken = () => {
    //     const token = localStorage.getItem("TOKEN");
    //     if (!token) {
    //         window.location.href = redirect;
    //     }
    // };

    const getShop = () => {
        const userId = localStorage.getItem('userId');
        axios.get(`${var_api}api/users-details/${userId}`)
            .then(response => console.log(response.data))
            .catch(error => handleError(error));
    };

    const getServices = () => {
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');
        axios.get(`${var_api}api/user-services/get-user-services/${userId}`, {
            headers: { 'Authorization': token }
        })
        .then(response => console.log(response.data))
        .catch(error => handleError(error));
    };

    const handleError = (error) => {
        if (error.response && error.response.status === 401) {
            // window.location.href = redirect;
            console.log("E", error.response);
        } else {
            console.error(error);
        }
    };

    const validateForm = () => {
        setIsRoleValid(!!role.trim());
        setIsDescriptionValid(!!description.trim());
        const isPermissionValid = permissionList.some(permission => permission.enabled);

        if (!isPermissionValid) {
            Swal.fire({
                title: "Pending!",
                text: "Select at least one of the permissions.",
                icon: "warning",
                confirmButtonColor: "#34c38f",
            });
        }

        return isRoleValid && isDescriptionValid && isPermissionValid;
    };

    const toggleCheckbox = (permissionId) => {
        setPermissionList(prev => prev.map(permission =>
            permission.id === permissionId ? { ...permission, enabled: !permission.enabled } : permission
        ));
        setSelectedPermissions(prev =>
            prev.includes(permissionId) ? prev.filter(id => id !== permissionId) : [...prev, permissionId]
        );
    };

    const getPermission = async () => {
        setLoading(true);
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${var_api}/api/super-permission/get`, {
                headers: { 'Authorization': token }
            });
            setPermissionList(response.data);
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    const getPermission1 = async () => {
        setLoading(true);
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${var_api}/api/role-details-permissions`, {
                headers: { 'Authorization': token }
            });
            setRoleList(response.data);
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    const submitRole = async () => {
        setFormSubmitted(true);

        if (!validateForm()) return;

        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');
        setLoading(true);

        const roleData = permissionList.map(permission => ({
            user_id: parseInt(userId),
            role_name: role,
            description: description,
            permission_id: permission.id,
            active_status: permission.enabled ? 1 : 0
        }));

        try {
            await axios.post(`${var_api}/api/role-master/bulk-post`, { roles: roleData }, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            });
            resetForm();
            getPermission();
            getPermission1();
            setPopup(false);
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setPopup(false);
        setRole('');
        setDescription('');
        setSelectedPermissions([]);
        setFormSubmitted(false);
        setPermissionList(prev => prev.map(permission => ({ ...permission, enabled: false })));
    };

       //close the modal
       const handleClose = () => setPopup(false);


       const getPermissionStatus = (role, permissionTitle) => {
        const permission = role.permissions.find(perm => perm.permission_title === permissionTitle);
        return permission ? permission.permission_active_status : 0;
      };
    
      const updatePermissionStatus = async (event, role, permissionTitle) => {
        const isChecked = event.target.checked ? 1 : 0;
    
        // Log the entire role object to ensure you see the structure
        console.log("Role object:", role);
        
    
        // Find the permission in the role's permissions array
        const permission = role.permissions.find(perm => perm.permission_title === permissionTitle);
        
        if (permission) {
            console.log("Permission found:", permission); // Log the permission object
            console.log("Permission ID:", permission.id); // Log the permission ID
    
            if ( permission.id) { // Ensure both IDs are available
                // Update the permission_active_status locally
      permission.permission_active_status = isChecked;
               
                await editRole( permission.id, permission.id, isChecked);
            } else {
                console.error("Role ID or Permission ID is missing."); // Log error if any ID is missing
            }
        } else {
            console.log("Permission not found for title:", permissionTitle); // Log if permission is not found
        }
    };
    
    
    
    
      const editRole = async (roleId, permissionId, activeStatus) => {
        setFormSubmitted(true);
        setLoading(true);
        const token = localStorage.getItem('token');
    
        try {
          const response = await axios.put(`${var_api}/api/role-master/put/${roleId}`, {
            active_status: activeStatus,
          }, {
            headers: {
              Authorization: token,
              'Content-Type': 'application/json',
            },
          });
    
          console.log(response.data);
          setLoading(false);
    
          // Refresh permission list
          getPermission();
    
          // Optionally close popup if necessary
          setPopup(false);
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            // window.location.href = redirectUrl;
          } else if (error.response && error.response.status === 400) {
            alert(error.response.data.error);
          } else {
            console.error(error);
          }
        }
      };

    return (
        <React.Fragment>

{isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       ROLE MASTER
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
<br/>

 <Card style={{ border: "none", maxWidth:"92rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
            <button className="btn" onClick={() => setPopup(true)} style={{ backgroundColor: 'rgb(89, 128, 71)', color: 'white' }}>
          Create Role
        </button>
            </div>

            <Table responsive className="mt-3">
                <thead>
                    <tr>
                        <th style={{ border: '1px solid black', padding: '8px', textAlign: 'left', width: '30%' }}>Permission Title</th>
                        {roleList.map((role, index) => (
                            <th key={`header_${index}`} style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{role.role_name}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {permissionList.map((permission, pIndex) => (
                        <tr key={`permission_${pIndex}`}>
                            <td style={{ border: '1px solid black', padding: '8px', textAlign: 'left' }}>{permission.permission_title}</td>
                            {roleList.map((role, rIndex) => (
                                <td key={`cell_${pIndex}_${rIndex}`} style={{ border: '1px solid black', padding: '8px' }}>
                                    <input
                                        type="checkbox"
                                        checked={getPermissionStatus(role, permission.permission_title) === 1}
                    onChange={(e) => updatePermissionStatus(e, role, permission.permission_title)}
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal
        show={popup}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size='md'
      >
        <Modal.Header closeButton>
          <Modal.Title> CREATE ROLE </Modal.Title>
        </Modal.Header>
        <Modal.Body>
                                <div className="form-group">
                                    <label htmlFor="role">Role</label>
                                    <input
                                        type="text"
                                        id="role"
                                        className={`form-control ${!isRoleValid && formSubmitted ? 'is-invalid' : ''}`}
                                        value={role}
                                        onChange={(e) => setRole(e.target.value)}
                                    />
                                    {!isRoleValid && formSubmitted && <div className="invalid-feedback">Role is required.</div>}
                                </div>
                                <br/>
                                <div className="form-group">
                                    <label htmlFor="description">Description</label>
                                    <input
                                        type="text"
                                        id="description"
                                        className={`form-control ${!isDescriptionValid && formSubmitted ? 'is-invalid' : ''}`}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    />
                                    {!isDescriptionValid && formSubmitted && <div className="invalid-feedback">Description is required.</div>}
                                </div>
                                <br/>
                                <div className="form-group">
                                    <label>Permissions</label>
                                    {permissionList.map((permission, index) => (
                                        <div key={index} className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={permission.enabled}
                                                onChange={() => toggleCheckbox(permission.id)}
                                            />
                                            <label className="form-check-label">{permission.permission_title}</label>
                                        </div>
                                    ))}
                                </div>
        
                            </Modal.Body>
        <Modal.Footer>
                                <button type="button" className="btn btn-secondary" onClick={() => setPopup(false)}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={submitRole}>Save</button>
        </Modal.Footer>
      </Modal>
                            
                        
            </Card>
        </React.Fragment>
    );
}
